module.exports = __webpack_public_path__ + "static/media/1.d469683e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16011/1.jpg
// module id = 504
// module chunks = 0